import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import { Post } from './Post';
import { ActiveMemberList } from '../Member/ActiveList';
import { AddReply } from './AddReply';
var moment = require('moment');
import * as Media from "react-media";
import * as classNames from "classnames";

@withRouter
export class ForumFeed extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {showAddPost: false};
        this.onPostToggleClicked = this.onPostToggleClicked.bind(this);
    }

    onPostToggleClicked() {
        this.setState({ showAddPost: !this.state.showAddPost });
    }

    onToggleClicked() {
        this.setState({ showDetail: !this.state.showDetail });
    }
    

    render() {

        const { userRole, currentUser, activeFilter, forum, ...props } = this.props;
        
        
        let posts = forum.posts; //this.sortPosts();
        let forumFeed = undefined;
        if (posts) {
            forumFeed = posts.map((item, index) => {
                let findAll = (!activeFilter || !activeFilter.id);
                let applyFilter = (activeFilter && item.tags.find(t => t.id === activeFilter.id));
                return (findAll || applyFilter) && !item.parentId ? <Post key={"reply" + index} item={item} {...this.props} /> : undefined;
            });
        }
        
        let addPostField = !this.props.singlePostView 
                            ?    this.state.showAddPost 
                                    ? <AddReply parentId={undefined} onCancelClicked={this.onPostToggleClicked} {...this.props}/> 
                                    : <div className="btn btn-primary btn-block clickable" onClick={this.onPostToggleClicked}>CREATE NEW POST</div>
                            : undefined;
        
        return (
                    <Media query="(max-width: 1023px)">
                        {
                        matches =>
                        {
                            return <div className="col-12 col-md-7 ">
                                    <div className="fixed-scrolling">
                                        {addPostField}
                                        <div className="fixed-scrolling-content">
                                            <div className={classNames("mt-2", {"overflow": !matches})}>
                                                {forumFeed}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                    }
                    </Media>);
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Forum/ForumFeed.tsx